import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { ButtonToolbar, Col, Row, Button, CardBody, Card } from "reactstrap";
import { Field, reduxForm } from 'redux-form';
import { Container, createTheme, Divider, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { List, ListItem, Grid, Paper, Typography, ThemeProvider } from '@mui/material';

import PndRestApi from "src/utils/pnd/PndRestApi";
import moment from 'moment';
import renderSelectField from "src/shared/components/form/Select";
import { showNotification, successNofication } from "src/shared/components/Notification";
import { Redirect } from 'react-router-dom';
import renderIntervalDatePickerField from "src/shared/components/form/IntervalDatePicker";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Fab from '@mui/material/Fab';
import { convertToHoursAndMinutes } from "src/utils/pnd/PndUtilities";

import { ERROR_MESSAGES, GREEN_COLOR } from "src/utils/pnd/PndConstants";
import ConfirmationDialog from "src/shared/components/ConfirmationDialog";


const DutyRoasterRegistration = ({ handleSubmit }) => {

    const theme = createTheme({
        typography: {
            fontFamily: 'ProductSansLight, sans-serif', // Use the custom font family
            h1: {
                fontFamily: 'ProductSansBold, sans-serif',

            },
            h2: {
                fontFamily: 'ProductSansBold, sans-serif',

            },
            h3: {
                fontFamily: 'ProductSansBold, sans-serif',
                fontSize: 40
            },
            h4: {
                fontFamily: 'ProductSansLight, sans-serif',
                fontSize: 20
            },
            h5: {
                fontFamily: 'ProductSansBold, sans-serif',
                fontSize: 20
            },

            h6: {
                fontFamily: 'ProductSansBold, sans-serif',
            },
            subtitle1: {
                fontFamily: 'ProductSansLight, sans-serif',
                fontSize: 20
            },

            body1: 'ProductSansLight, sans-serif',
        },

    });


    const [isApiError, setApiError] = useState(false);
    const [assignedItems, setAssignedItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedShifts, setSelectedShifts] = useState({});
    const [isRedirect, setIsRedirect] = useState(false);
    const [isNextWeekDates, setNextWeekDates] = useState([]);
    const [dateRange, setDateRange] = useState({});
    const [applyToAll, setApplyToAll] = useState(false);
    const [firstRowShiftSelected, setFirstRowShiftSelected] = useState(false);
    const [selectedRiders, setSelectedRiders] = useState([]);
    const [riderList, setRiderList] = useState([]);
    const [isInitialLoad, setInitialLoad] = useState(false);
    const [bulkShift, setBulkShift] = useState(null); // shift selected in the bulk-apply bar
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [pendingPayload, setPendingPayload] = useState(null);
    const [confirmMessage, setConfirmMessage] = useState("");

    useEffect(() => {
        getAllHubDutyShiftConfig();
        getAllOnDutyRidersDetails();
        setInitialLoad(true);
    }, []);

    useEffect(() => {
        if (dateRange.start && dateRange.end) {
            updateDatesBasedOnRange(dateRange.start, dateRange.end);
        }
    }, [dateRange]);
    const updateDatesBasedOnRange = (start, end) => {
        const dateList = [];
        let currentDate = moment(start);

        while (currentDate <= moment(end)) {
            const dayOfWeek = currentDate.format('dddd');
            const formattedDate = currentDate.format('YYYY-MM-DD');
            dateList.push({ dayOfWeek, formattedDate });
            currentDate.add(1, 'day');
        }
        setNextWeekDates(dateList);
    };
    const back = () => {
        setIsRedirect(true);
    }
    const getAllOnDutyRidersDetails = async () => {
        try {

            setLoading(true);
            const response = await PndRestApi.GetAllOnDutyRidersDetails();
            if (response.status === 200 && response.data.status === 200) {
                setInitialLoad(false);
                const modifiedData = response.data.data.map((item) => ({
                    name: item.riderName,
                    id: item.riderId,
                    dutyStatusId: item?.availabilityInfo?.riderAvailabilityId,
                    dutyStatusName: item?.availabilityInfo?.riderAvailabilityDesc,
                }));

                setRiderList(modifiedData)
            } else {
                setApiError(true);
            }
        } catch (error) {
            console.log("Error in getAllOnDutyRidersDetails", error);
            setApiError(true);
        } finally {
            setLoading(false);
        }
    };

    // const getAllHubDutyShiftConfig = async () => {
    //     let shiftInfoList = [];
    //     try {
    //         setLoading(true);
    //         const response = await PndRestApi.GetAllHubDutyShiftConfigByCustomerIdAndHubId();
    //         if (response.status === 200 && response.data.status === 200) {
    //             response.data.data.forEach(item => {
    //                 shiftInfoList.push({ label: item?.shiftTypesInfo?.shiftName + " (" + convertToHoursAndMinutes(item?.shiftStartTime) + "-" + convertToHoursAndMinutes(item?.shiftEndTime) + ")", value: item?.shiftId });
    //             });
    //             setAssignedItems(shiftInfoList);
    //         } else {
    //             setApiError(true);
    //         }
    //     } catch (error) {
    //         setApiError(true);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const getAllHubDutyShiftConfig = async () => {
        let shiftInfoList = [];
        try {
            setLoading(true);
            const response = await PndRestApi.GetAllHubDutyShiftConfigByCustomerIdAndHubId();
            if (response.status === 200 && response.data.status === 200) {
                const now = new Date(); // Current date and time
                const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate()); // Midnight of the current day

                // Calculate milliseconds since midnight
                const millisecondsSinceMidnight = now - midnight;
                response.data.data.forEach(item => {
                    const shiftStartTime = item?.shiftStartTime; // In milliseconds
                    const shiftEndTime = item?.shiftEndTime; // In milliseconds

                    // Only add to list if shiftEndTime is greater than the current time
                    //if (shiftEndTime && shiftEndTime > millisecondsSinceMidnight) {
                    shiftInfoList.push({ label: item?.shiftTypesInfo?.shiftName + " (" + convertToHoursAndMinutes(item?.shiftStartTime) + "-" + convertToHoursAndMinutes(item?.shiftEndTime) + ")", value: item?.shiftId });
                    // }
                });
                setAssignedItems(shiftInfoList);
            } else {
                setApiError(true);
            }
        } catch (error) {
            setApiError(true);
        } finally {
            setLoading(false);
        }
    };

    const handleShiftChange = (day, shiftId) => {
        if (applyToAll) {
            const newShifts = {};
            isNextWeekDates.forEach(date => {
                newShifts[date.formattedDate] = shiftId;
            });
            setSelectedShifts(newShifts);
        } else {
            setSelectedShifts(prevState => ({
                ...prevState,
                [day]: shiftId,
            }));
            if (day === isNextWeekDates[0].formattedDate) {
                setFirstRowShiftSelected(true);
            }
        }
    };

    const saveRoasterData = async (payload, isOverwrite = false) => {
        try {
            const reqObj = { ...payload };
            if (isOverwrite) {
                reqObj["isOverWrite"] = true;
            }else{
                reqObj["isOverWrite"] = false;
            }

            const response = await PndRestApi.SaveRiderRoasterData(reqObj);
            const resStatus = response?.data?.status || response?.status;
            const resMessage = response?.data?.message || "";

            if (response.status === 200 && response.data?.status === 200) {
                successNofication(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message: ${"Successfully Added Rider Roaster Details"}`,
                );
                setIsRedirect(true);
            } else if (
                resStatus === 500 &&
                (resMessage.includes("overlapping") || resMessage.includes("already assigned"))
            ) {
                if (!isOverwrite) {
                    setPendingPayload(payload);
                    setConfirmMessage(resMessage || "Duty is already assigned or overlapping with an existing duty for the rider.");
                    setConfirmDialogOpen(true);
                } else {
                    showNotification(
                        "theme-light",
                        "ltr",
                        `SuccessCode: ${resStatus}`,
                        `Message: ${resMessage}`,
                    );
                }
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${resStatus}`,
                    `Message: ${resMessage}`,
                );
            }
        } catch (error) {
            const errMsg = error?.response?.data?.message || ERROR_MESSAGES.tryCatchError;
            const errStatus = error?.response?.data?.status || error?.response?.status || 500;

            if (errStatus === 500 && (errMsg.includes("overlapping") || errMsg.includes("already assigned"))) {
                if (!isOverwrite) {
                    setPendingPayload(payload);
                    setConfirmMessage(errMsg || "Duty is already assigned or overlapping with an existing duty for the rider.");
                    setConfirmDialogOpen(true);
                } else {
                    showNotification(
                        "theme-light",
                        "ltr",
                        `SuccessCode: ${errStatus}`,
                        errMsg,
                    );
                }
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${errStatus}`,
                    errMsg,
                );
            }
        }
    };

    const handleSubmitForm = async () => {
        let Obj = {};

        const selectedShiftsArray = Object.entries(selectedShifts).map(([day, shift]) => ({
            day: day,
            shiftId: shift.value
        }));
        Obj["shiftInfo"] = selectedShiftsArray;

        const idsAsString = selectedRiders.map(item => String(item.id)).join(', ');
        Obj["riderIds"] = idsAsString;

        console.log(selectedRiders, 'selectedRiders');

        await saveRoasterData(Obj, false);
    };


    const toggleSelection = item => {
        setSelectedRiders(prevItems =>
            prevItems.includes(item)
                ? prevItems.filter(selectedItem => selectedItem !== item)
                : [...prevItems, item]
        );

        // Clear date range if no riders are selected
        if (selectedRiders.length === 0) {
            setDateRange({});
        }
    };




    if (isRedirect) {
        return <Redirect to="/web_app/rider/duty_roaster/view" />;
    }

    if (riderList && riderList.length === 0 && !isInitialLoad) {
        return (
            <ThemeProvider theme={theme}>
                <Container
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        minHeight: "70vh", // Optional: for vertical centering on full height
                    }}
                >
                    <Typography variant='h3' align="center">
                        Currently, no riders are available or on duty.
                    </Typography>
                    <Typography variant='body1' align="center">
                        You can add new riders by asking your admin or check the status of your riders.
                    </Typography>
                </Container>
            </ThemeProvider>

        )
    }


    return (
        <ThemeProvider theme={theme}>
            <Card>
                <CardBody>
                    <Row>
                        <div>
                            <Fab size="large" color="primary" aria-label="add"
                                style={{
                                    float: "right",
                                    marginLeft: 20,
                                    marginRight: 20,
                                    backgroundColor: "#1EAA5D"
                                }} onClick={() => back()}>
                                <ArrowBackIcon />
                            </Fab>

                        </div>
                        <div>
                            <Typography variant="h3">Rider Duty Roster</Typography>
                            <Typography variant="h4">Select one or more riders to assign new duties.</Typography>
                        </div>
                    </Row>
                </CardBody>
                <CardBody>
                    <form className="form-animated" onSubmit={handleSubmit(handleSubmitForm)}>
                        <Col lg={12} md={12}>
                            <Row>
                                {/* Left Column - CHOOSE RIDER */}
                                <Col lg={6} md={7}>
                                    <Grid item xs={5}>
                                        <Paper variant="outlined" style={{ height: '300px', padding: '20px', display: 'flex', flexDirection: 'column', borderRadius: '10px' }}>
                                            <Typography variant="h5" align="left" gutterBottom>
                                                CHOOSE RIDER
                                            </Typography>
                                            <Divider />

                                            <List dense style={{ flex: 1, overflowY: 'auto', maxHeight: '300px' }}> {/* Set maxHeight for scrolling */}
                                                {

                                                    riderList.map((item, index) => (
                                                        <ListItem
                                                            key={index}
                                                            sx={{
                                                                backgroundColor: selectedRiders.includes(item) ? GREEN_COLOR : 'white', // Adjust background color for selected
                                                                '&:hover': {
                                                                    backgroundColor: selectedRiders.includes(item) ? GREEN_COLOR : 'grey.100', // Change on hover
                                                                },
                                                                marginTop: 0.5
                                                            }}
                                                            onClick={() => toggleSelection(item)} // Toggle selection on click
                                                            button
                                                        >
                                                            <Typography
                                                                variant="subtitle1"
                                                                sx={{
                                                                    color: selectedRiders.includes(item) ? 'white' : 'black', // Text color based on selection
                                                                    fontWeight: selectedRiders.includes(item) ? 'bold' : 'normal', // Optional: Bold text when selected
                                                                }}
                                                            >
                                                                {item.name}
                                                            </Typography>
                                                        </ListItem>
                                                    ))



                                                }


                                            </List>
                                        </Paper>
                                    </Grid>
                                </Col>

                                {/* Right Column - SHIFT START DATE AND END DATE */}

                                {selectedRiders.length != 0 && (<Col lg={6} md={5}>
                                    <Grid item xs={5}>
                                        <Paper variant="outlined" style={{ height: '300px', padding: '20px', display: 'flex', flexDirection: 'column', borderRadius: '10px', justifyContent: "center" }}>
                                            <Typography variant="h5" align="left" gutterBottom>
                                                SHIFT START DATE AND END DATE
                                            </Typography>
                                            <Divider />
                                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                                <Field
                                                    name="dateRange"
                                                    component={renderIntervalDatePickerField}
                                                    type="text"
                                                    setDateRange={setDateRange}
                                                />

                                            </div>
                                        </Paper>
                                    </Grid>
                                </Col>)}
                            </Row>

                            {/* Table Section */}
                            {dateRange?.start && dateRange?.end && selectedRiders.length != 0 && (
                                <>
                                    {/* ── Bulk Apply Bar ─────────────────────────────── */}
                                    <Row style={{ marginTop: '2%' }}>
                                        <Col xs={12}>
                                            <div style={{
                                                background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
                                                border: '1.5px solid #86efac',
                                                borderRadius: 12,
                                                padding: '14px 18px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                flexWrap: 'wrap',
                                                gap: 12,
                                            }}>
                                                <span style={{ fontWeight: 700, fontSize: '0.85rem', color: '#166534', whiteSpace: 'nowrap' }}>
                                                    ⚡ Bulk Apply:
                                                </span>

                                                {/* Shift Picker for bulk */}
                                                <div style={{ minWidth: 240, flex: 1 }}>
                                                    <select
                                                        onChange={(e) => {
                                                            const val = e.target.value;
                                                            if (!val) return;
                                                            const shift = assignedItems.find(s => String(s.value) === val);
                                                            setBulkShift(shift || null);
                                                        }}
                                                        style={{
                                                            width: '100%', padding: '6px 10px', borderRadius: 8,
                                                            border: '1.5px solid #86efac', fontSize: '0.82rem',
                                                            background: '#fff', cursor: 'pointer',
                                                        }}
                                                        defaultValue=""
                                                    >
                                                        <option value="" disabled>Select shift to bulk apply...</option>
                                                        {assignedItems.map(s => (
                                                            <option key={s.value} value={s.value}>{s.label}</option>
                                                        ))}
                                                    </select>
                                                </div>

                                                {/* Action Buttons */}
                                                {[
                                                    { label: '📅 All Days', filter: () => true },
                                                    { label: '🗓 Weekdays', filter: d => !['Saturday', 'Sunday'].includes(d.dayOfWeek) },
                                                    { label: '🏖 Weekends', filter: d => ['Saturday', 'Sunday'].includes(d.dayOfWeek) },
                                                ].map(({ label, filter }) => (
                                                    <button
                                                        key={label}
                                                        type="button"
                                                        onClick={() => {
                                                            if (!bulkShift) {
                                                                showNotification("theme-light", "ltr", "Select a Shift", "Please select a shift from the dropdown first.");
                                                                return;
                                                            }
                                                            const newShifts = { ...selectedShifts };
                                                            isNextWeekDates.filter(filter).forEach(d => {
                                                                newShifts[d.formattedDate] = bulkShift;
                                                            });
                                                            setSelectedShifts(newShifts);
                                                        }}
                                                        style={{
                                                            padding: '6px 14px', borderRadius: 20,
                                                            border: '1.5px solid #16a34a',
                                                            background: '#16a34a', color: '#fff',
                                                            fontWeight: 700, fontSize: '0.78rem',
                                                            cursor: 'pointer', whiteSpace: 'nowrap',
                                                            transition: 'all 0.2s',
                                                        }}
                                                        onMouseEnter={e => e.currentTarget.style.background = '#15803d'}
                                                        onMouseLeave={e => e.currentTarget.style.background = '#16a34a'}
                                                    >
                                                        {label}
                                                    </button>
                                                ))}

                                                {/* Clear All */}
                                                <button
                                                    type="button"
                                                    onClick={() => setSelectedShifts({})}
                                                    style={{
                                                        padding: '6px 14px', borderRadius: 20,
                                                        border: '1.5px solid #dc2626',
                                                        background: '#fff', color: '#dc2626',
                                                        fontWeight: 700, fontSize: '0.78rem',
                                                        cursor: 'pointer', whiteSpace: 'nowrap',
                                                        transition: 'all 0.2s',
                                                    }}
                                                    onMouseEnter={e => { e.currentTarget.style.background = '#dc2626'; e.currentTarget.style.color = '#fff'; }}
                                                    onMouseLeave={e => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.color = '#dc2626'; }}
                                                >
                                                    ✕ Clear All
                                                </button>
                                            </div>
                                        </Col>
                                    </Row>

                                    {/* ── Per-Day Table ───────────────────────────────── */}
                                    <Row style={{ marginTop: '1.5%', display: 'flex', justifyContent: 'center' }}>
                                        <div style={{ width: '98%', display: 'flex', justifyContent: 'center' }}>
                                            <Table style={{ width: '100%', borderRadius: '10px' }}>
                                                <TableHead>
                                                    <TableRow style={{ background: '#21b368' }}>
                                                        <TableCell style={{ border: '1px solid #ccc', color: 'white' }}>
                                                            <Typography variant="h4">Date</Typography>
                                                        </TableCell>
                                                        <TableCell style={{ border: '1px solid #ccc', color: 'white' }}>
                                                            <Typography variant="h4">Day</Typography>
                                                        </TableCell>
                                                        <TableCell style={{ border: '1px solid #ccc', color: 'white' }}>
                                                            <Typography variant="h4">Shift Details</Typography>
                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {isNextWeekDates.map((day, index) => (
                                                        <TableRow key={index} style={{ background: selectedShifts[day.formattedDate] ? '#f0fdf4' : 'white' }}>
                                                            <TableCell style={{ border: '1px solid #ccc', color: 'black' }}>
                                                                <Typography variant="h4">{day.formattedDate}</Typography>
                                                            </TableCell>
                                                            <TableCell style={{ border: '1px solid #ccc', color: 'black' }}>
                                                                <Typography variant="h4" style={{ color: ['Saturday', 'Sunday'].includes(day.dayOfWeek) ? '#dc2626' : 'inherit' }}>
                                                                    {day.dayOfWeek}
                                                                </Typography>
                                                            </TableCell>
                                                            <TableCell style={{ border: '1px solid #ccc', color: 'black' }}>
                                                                <Field
                                                                    name={`shift_${day.formattedDate}`}
                                                                    component={renderSelectField}
                                                                    type="text"
                                                                    options={assignedItems}
                                                                    label="Shift"
                                                                    placeholder="Select Shift"
                                                                    input={{
                                                                        value: selectedShifts[day.formattedDate] || '',
                                                                        onChange: (event) => handleShiftChange(day.formattedDate, event),
                                                                    }}
                                                                />
                                                                {selectedShifts[day.formattedDate] && (
                                                                    <span style={{ fontSize: '0.7rem', color: '#16a34a', fontWeight: 700 }}>✓ {selectedShifts[day.formattedDate].label}</span>
                                                                )}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </div>
                                    </Row>

                                    <ButtonToolbar
                                        className="form__button-toolbar wizard__toolbar"
                                        style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}
                                    >
                                        <Button color="primary" className="next" type="submit">
                                            Submit
                                        </Button>
                                    </ButtonToolbar>
                                </>

                            )}

                        </Col>

                    </form>



                </CardBody >
            </Card >
            <ConfirmationDialog
                open={confirmDialogOpen}
                onClose={() => {
                    setConfirmDialogOpen(false);
                    setPendingPayload(null);
                }}
                onConfirm={() => {
                    setConfirmDialogOpen(false);
                    if (pendingPayload) {
                        saveRoasterData(pendingPayload, true);
                    }
                }}
                title="Confirm Duty Overwrite"
                message={`${confirmMessage || "Duty is already assigned or overlapping with an existing duty for the rider."} Do you want to overwrite the Duty?`}
            />
        </ThemeProvider>

    );
};

DutyRoasterRegistration.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
};

const mapStateToProps = (state, data) => {
    if (data && data.data && data.isId != null) {
        return {
            initialValues: {
                menuLinkingUrl: data.data?.menuLinkingUrl,
                menuLabel: data.data?.menuLabel,
                menuName: data.data?.menuName,
                status: data?.data?.status,
                appProductId: { value: data?.data?.appProductId, label: data?.data?.appProductName },
                isCreatePresent: data?.data?.isCreatePresent,
                isViewPresent: data?.data?.isViewPresent,
                isUpdatePresent: data?.data?.isUpdatePresent,
                isDeletePresent: data?.data?.isDeletePresent,
                menuId: { value: data?.data?.parentMenuId, label: data?.data?.parentMenuName },
                menuLabelHierachy: data?.data?.menuLabelHierachy,
                subMenuId: { value: data?.data?.parentSubMenuId, label: data?.data?.parentSubMenuName },
            }
        }
    }
}

export default connect(mapStateToProps)(reduxForm({ form: 'DutyRoasterRegistrationForm', enableReinitialize: true })(DutyRoasterRegistration));
